import { Link } from "@tanstack/react-router"

export function IntegrationLayout() {
	return (
		<>
			<Link
				to="/settings/integrations"
				className={`mx-auto flex w-[90%] max-w-[930px] items-center gap-2 py-4 text-lg text-secondary hover:text-primary`}
			></Link>
		</>
	)
}
